import { render, staticRenderFns } from "./infomenu.vue?vue&type=template&id=61e4a25c&"
import script from "./infomenu.vue?vue&type=script&lang=js&"
export * from "./infomenu.vue?vue&type=script&lang=js&"
import style0 from "./infomenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports